import React, { useRef, useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

const moveTicker = (distance) => keyframes`
  0% {
    transform: translateX(70%);
  }
  100% {
    transform: translateX(-${distance}px);
  }
`;

const Wrapper = styled.div`
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  color: white;
  margin-bottom: 90px;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  ${'' /* animation: ${(props) => moveTicker(props?.distance)} 50s linear infinite; */}
  width: 100%; /* Ensure it takes the full width */
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 30px;
`;

const TrustedPartner = ({ items, handleLoop }) => {
  const innerRef = useRef(null);
  const [distance, setDistance] = useState(0);

  useEffect(() => {
    const element = innerRef.current;
    if (element) {
      const totalWidth = element.scrollWidth;
      setDistance(totalWidth);
    }
  }, [items]);

  return (
    <Wrapper>
      <Inner ref={innerRef} distance={distance} onAnimationEnd={handleLoop}>
        {items?.map((obj, index) => (
          <ImageWrapper key={obj.key + index}>{obj.img}</ImageWrapper>
        ))}
      </Inner>
    </Wrapper>
  );
};

export default TrustedPartner;
